// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_f-2";
export var blackBorderOnHover = "_f-7";
export var cell = "_f-6";
export var cellContainer = "_f-3";
export var checked = "_f-8";
export var disabled = "_f-5";
export var featuredIconCellContainer = "_f-9";
export var featuredIconTextContainer = "_f-b";
export var featuredIconWrapper = "_f-a";
export var noBorder = "_f-c";
export var orangeSelectedRow = "_1b-3";
export var overflowableText = "_f-0";
export var overflowableTextContainer = "_f-1";
export var row = "_j-0";
export var rowCheckboxCell = "_f-4";
export var selectableTable = "_1b-2";